'use strict';

class Home extends BaseComponent {
	constructor(element, state) {
		//init BaseComponent
		super(element, state);

		//set template id
		this._view = $('#home_Home').html();

		//set template props
		this._props = {
			floorplan_image_src: _t('home_floorplan_image_src'),
			btn01_title: _t('home_btn01_title'),
			btn02_title: _t('home_btn02_title'),
			btn03_title: _t('home_btn03_title'),
			btn04_title: _t('home_btn04_title'),
			btn05_title: _t('home_btn05_title'),
			btn06_title: _t('home_btn06_title'),
			btn07_title: _t('home_btn07_title'),
			terms_of_use: _t('home_terms_of_use'),
		};

		this.markers = {};

		_.bindAll(this, 'onUpdateSite');

		return this
	}

	init() {
		Utils.ajaxify($('a', this.$el));

		this.markers.Page01 = $('.marker.page01', this.$el);
		this.markers.Page02 = $('.marker.page02', this.$el);
		this.markers.Page03 = $('.marker.page03', this.$el);
		this.markers.Page04 = $('.marker.page04', this.$el);
		this.markers.Page05 = $('.marker.page05', this.$el);

		site.instance.$el.on(ComponentEvent.UPDATE_STATE, this.onUpdateSite);

		this.$floorplan = $('.floorplan-wrapper', this.$el);
		this.$btn01 = $('a.page01', this.$el);
		this.$btn02 = $('a.page02', this.$el);
		this.$btn03 = $('a.page03', this.$el);
		this.$btn04 = $('a.page04', this.$el);
		this.$btn05 = $('a.page05', this.$el);
		this.$linkTerms = $('a.link-terms', this.$el);

		//fade in animation
		this.fadeHideElement(this.$floorplan)
			.fadeHideElement(this.$btn01)
			.fadeHideElement(this.$btn02)
			.fadeHideElement(this.$btn03)
			.fadeHideElement(this.$btn04)
			.fadeHideElement(this.$btn05)
			.fadeHideElement(this.$linkTerms);

		this.timeline = new TimelineLite();
		this.timeline.call(this.fadeInElement, [this.$floorplan], this, "+=0.3");
		this.timeline.call(this.fadeInElement, [this.$btn01], this, "+=0.2");
		this.timeline.call(this.fadeInElement, [this.$btn02], this, "+=0.2");
		this.timeline.call(this.fadeInElement, [this.$btn03], this, "+=0.2");
		this.timeline.call(this.fadeInElement, [this.$btn04], this, "+=0.2");
		this.timeline.call(this.fadeInElement, [this.$btn05], this, "+=0.2");
		this.timeline.call(this.fadeInElement, [this.$linkTerms], this, "+=0.2");
		this.timeline.play();


		return this.onUpdateSite();
	}

	onUpdateSite(){
		let visitedPages = site.instance.pages;

		for(let page in visitedPages) {
			let cName = visitedPages[page].constructor.name;
			if(this.markers[cName]) {
				this.markers[cName].addClass('visited');
			}
		}

		return this;
	}
}

if(!_.isObjectLike(site)) var site = {components:{}};
site.components.Home = Home;
